import moment from "moment";

class Project {
	constructor(model = {}) {
    this.id = model.id;
    this.farmpactId = model.farmpact_project_id;
    this.name = model.name;
    this.description = model.description;
    this.address = model.address || '';
    this.currentPractices = model.med_curr_farm_practices || '';
    this.country = model.country;
    this.isAgroforestry = model.af_status;
    this.parcels = model.parcels;
    this.date = model.timestamp;
    this.farms = model.farms;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name || 'Uknown';
  }

  getDescription() {
    return this.description || 'No description'
  }

  getCountry() {
    return this.country[0];
  }

  getAddress() {
    return this.address || 'No address';
  }

  getCurrentPractices() {
    return this.currentPractices || 'No current practices';
  }

  isAgroforestry() {
    return this.isAgroforestry;
  }

  getNumberOfParcels() {
    let parcels = this.parcels || [];
    return parcels.length;
  }
  
  getDate(){
    return moment(this.date).format('DD/MMMM/YYYY')
  }

  getFarms() {
    return this.farms;
  }
}

export default Project;